<template>
  <card-component title="Ingresa tu usuario de Workvivo" icon="lock" :has-card-header-background="true" :has-button-slot="true">
    <form @submit.prevent="submit" method="POST">
      <b-field>
        <template #label>
          Tu usuario Workvivo es DNI@mifarma<br><br>
          (Ejemplo: 12345678@mifarma)
        </template>
        <b-input
          v-model="dni"
          name="dni"
          validation-message="Recuerda que debes escribir tu correo Workvivo: DNI@mifarma"
          pattern="^[0-9]+@[mM][iI][fF][aA][rR][mM][aA]$"
          required
          autofocus
        />
      </b-field>
      <hr>
      <div class="control">
        <b-button native-type="submit" class="button is-orange" expanded :class="{'is-loading':isLoadingStartClaim}">
          Activar Cuenta
        </b-button>
      </div>
    </form>
    <b-modal :active.sync="isImageModalActive" has-modal-card>
      <div class="modal-card" style="width: auto">
        <footer class="modal-card-foot is-flex justify-content-end">
            <b-button
                label="Registrarme"
                type=is-orange
                @click="showDynamicPopup('login')" />
            <b-button
                @click="showDynamicPopup('password')"
                label="Cambiar contraseña" />
        </footer>
      </div>
    </b-modal>
  </card-component>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'
import ValidDNIRepository from '@/services/ValidDNIRepository'

export default {
  name: 'StartClaim',
  components: { CardComponent },
  data () {
    return {
      isImageModalActive: true,
      isLoadingStartClaim: false,
      isLoadingChangePassword: false,
      dni: null
    }
  },
  mounted () {
    // this.showInitialDialog()
    // this.$buefy.dialog.alert('¡Bienvenido! a Workvivo mifarma!<br><br>Lee y sigue los pasos cuidadosamente para poder conectarte :)<br><br> En la siguiente pantalla, cuando soliciten tu correo deberás colocar lo siguiente:<br><br>CORREO: DNI@mifarma <br>(ej.46551234@mifarma)<br><br>¿Olvidaste tu contraseña?<br> No te preocupes, sigue los siguientes pasos para poder recuperarla.')
  },
  created () {
    if (this.idUser === null) {
      this.$router.push('/start-claim')
    }
  },
  methods: {
    submit () {
      this.isLoadingStartClaim = true
      setTimeout(() => {
        this.isLoading = false
        this.$store.dispatch('startClaim', this.dni.toLowerCase()
        ).then(r => {
          console.log(r)
          TokenRepository.getClaimedStatus(this.dni.toLowerCase()
          ).then(r => {
            console.log(r)
            if (r.data.claimed) {
              console.log('gi')
              this.$router.push('/answer-questions')
            } else {
              console.log('gias')
              this.$router.push('/answer-questions')
            }
          })
        }).catch((error) => {
          console.log(error)
          this.isLoadingStartClaim = false
          this.showErrorToast(error)
        })
      }, 750)
    },
    showDynamicPopup (type) {
      let message = ''
      this.isImageModalActive = false
      if (type === 'login') {
        message = '¡Bienvenido a Workvivo Mifarma!<br><br>Lee las indicaciones y sigue los pasos para conectarte.'
      } else if (type === 'password') {
        message = '¿Olvidaste tu contraseña?<br> No te preocupes, sigue los siguientes pasos para poder recuperarla.'
      }
      this.$buefy.dialog.alert({
        message: message,
        hasIcon: true,
        type: 'is-orange',
        confirmText: 'OK'
      })
    },
    showInitialDialog () {
      this.$buefy.dialog.confirm({
        confirmText: 'Cambiar contraseña',
        cancelText: 'Registrarme',
        trapFocus: true,
        hasIcon: true,
        onConfirm: () => {
          this.showDynamicPopup('password')
        },
        onCancel: () => {
          this.showDynamicPopup('login')
        }
      })
    },
    changePassword () {
      if (this.dni) {
        this.isLoadingChangePassword = true
        ValidDNIRepository.changePassword(this.dni)
          .then((r) => {
            this.requestToken(r.data.user_id, r.data)
          }).catch(e => {
            this.isLoadingChangePassword = false
            this.showErrorToast(e)
          })
      }
    },
    showErrorToast (error) {
      let type = 'is-danger'
      let message = 'Parece que ha ocurrido un error con el registro. Vuelve a ingresar tu correo Workvivo, y en caso no se solucione, haz clic <a href="https://forms.office.com/r/YzsDyn6Ztc" target="_blank"><b>AQUÍ</b></a> para poder ayudarte.'
      if (error.response.status === 400) {
        type = 'is-info'
        message = error.response.data.detail
      }
      this.$buefy.dialog.alert({
        title: 'Error',
        message: message,
        type: type,
        ariaRole: 'alertdialog',
        ariaModal: true,
        hasIcon: true // Para mostrar el ícono junto al mensaje
      })
    },
    requestToken (id, data) {
      TokenRepository.requestTokenSMS(id, data)
        .then((r) => {
          this.isLoadingChangePassword = false
          this.promptToken(id, data.phone_number)
        }).catch(e => {
          this.isLoadingChangePassword = false
          this.$buefy.toast.open({
            message: `Error: ${e.response.data.detail}`,
            type: 'is-danger'
          })
        })
    },
    getTokenSMS (token) {
      return {
        token_sms: token
      }
    },
    promptToken (idUser, phoneNumber) {
      this.$buefy.dialog.prompt({
        message: 'Escribe el código enviado al número ' + phoneNumber,
        inputAttrs: {
          type: 'text'
        },
        confirmText: 'Enviar Código',
        cancelText: 'Cancelar',
        trapFocus: true,
        closeOnConfirm: false,
        canCancel: ['escape', 'button'],
        onConfirm: (value, { close }) => {
          this.isLoading = true
          this.$buefy.toast.open('Validando código ...')
          TokenRepository.claimWorkplaceURL(idUser, this.getTokenSMS(value))
            .then((r) => {
              this.$store.commit('removeIDUser')
              window.location.replace(r.data.url_to_claim)
            }).catch(e => {
              this.isLoading = false
              this.$buefy.toast.open({
                message: `Error: ${e.response.data.detail}`,
                type: 'is-danger'
              })
            })
        },
        onCancel: () => {
          this.phoneNumber = null
        }
      })
    }
  }
}
</script>
<style>
body  .button.custom-grey {
  background-color: #ce0909 !important; /* El color que tú quieras */
  color: #fff !important;               /* El color del texto */
  border: none !important;
}
.is-orange {
  background-color: #EF7D01 !important;
  color: #fff !important;
  border: none;
}
</style>
